// The workflow-registry ids the web app gates pages and features on. The
// registry (Firestore `workflow_agents` + `workflow_visibility`) enables each
// one per workspace from the admin Workflow Visibility panel.
//
// Which dashboards a user is offered in the menus, palette and search is the
// server's decision (`dashoneNavigation`). These ids serve the route guards and
// the pages that read the registry directly through `isWorkflowVisible`.

export const KEY_ACCOUNTS_WORKFLOW_ID = 'key-accounts';
export const ACCOUNTS_WORKFLOW_ID = 'accounts';

// The DSF ↔ Outlet toggle is a feature inside Key Accounts, gated per workspace
// on its own id so it can be enabled where the physical outlet matching is good
// enough. Key Accounts reads it directly via `isWorkflowVisible`.
export const OUTLET_VIEW_WORKFLOW_ID = 'key-accounts-outlet-view';
